var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80938 2.79297H2.24469C1.44659 2.79297 0.800171 3.47839 0.800171 4.32272V11.97C0.800171 12.8151 1.44659 13.4998 2.24469 13.4998H10.1896C10.9877 13.4998 11.6341 12.8151 11.6341 11.97V6.37249L8.80715 9.36554C8.56029 9.62952 8.23878 9.81194 7.88555 9.88845L5.94917 10.2987C4.68521 10.5659 3.57148 9.38648 3.82428 8.04886L4.21141 5.99836C4.28147 5.62856 4.45336 5.28838 4.70543 5.02186L6.80938 2.79297Z",
    fill: "#A9A8B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9678 1.45125C12.8948 1.26637 12.7877 1.09684 12.6522 0.951443C12.5189 0.809251 12.3582 0.695499 12.1798 0.617037C12.0041 0.539853 11.8142 0.5 11.6223 0.5C11.4303 0.5 11.2404 0.539853 11.0647 0.617037C10.8863 0.695499 10.7256 0.809251 10.5923 0.951443L10.198 1.36891L12.2578 3.55014L12.6522 3.13195C12.7892 2.98766 12.8964 2.81783 12.9678 2.63214C13.1166 2.25257 13.1166 1.83082 12.9678 1.45125ZM11.2373 4.63136L9.17668 2.44941L5.72644 6.10405C5.67554 6.15829 5.64121 6.22595 5.62749 6.29906L5.24036 8.35028C5.18981 8.61751 5.41298 8.85297 5.66505 8.79952L7.60215 8.39C7.67264 8.37429 7.73679 8.33781 7.78633 8.28527L11.2373 4.63136Z",
    fill: "#A9A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrey);
export default __webpack_public_path__ + "static/media/edit_grey.b5f14f2bc9d729efb37b77515a042d7f.svg";
export { ForwardRef as ReactComponent };